import React from 'react'
import {KeywordSpan, WrapperKeyword, WrapperKeywords} from "./thumb_label.style";

export default function KeywordUI({thumb_label}) {


    return (
        <div>
            <WrapperKeywords>
                {typeof (thumb_label) === "object" && thumb_label?.map((label, index) => (
                    <WrapperKeyword key={index}>
                        <KeywordSpan title={label}>{label}</KeywordSpan>
                    </WrapperKeyword>
                ))}
            </WrapperKeywords>
        </div>
    )
}



// WEBPACK FOOTER //
// ./src/estimate_list/components/list/thumb_label/thumb_label.presenter.js